module.exports = "<div class=\"mt-59px mt-md-80px\">\r\n    <jujo_content></jujo_content>\r\n</div>"